import React, { useState, useEffect } from 'react';
import './Navbar.css';
//import LogoText from './LogoText';
import LogoImage from "./LogoImage";
import Icon from "./Icon";
import {faUserChef} from "@fortawesome/pro-solid-svg-icons";

const Navbar: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isSmall, setIsSmall] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);

    // Event-Listener, der prüft, ob das Fenster vergrößert wird
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 720) {
                if (isOpen) setIsOpen(false);
                setIsSmall(false);
            } else {
                setIsSmall(true);
            }
        };

        // Event-Listener hinzufügen
        window.addEventListener('resize', handleResize);

        // Cleanup-Funktion, um den Event-Listener zu entfernen
        return () => window.removeEventListener('resize', handleResize);
    }, [isOpen]);

    return (
        <nav className="navbar">
            <div className={`${isSmall ? "navbar-container-small" : "navbar-container"}`}>
                <LogoImage />
                <div className="navbar-applogo">
                    <Icon icon={faUserChef} color="white" className="icon"/>
                    <h4>AI-Chef</h4>
                </div>
                <div className="navbar-toggle" onClick={toggleMenu}>
                    <i className="fas fa-bars"></i>
                </div>
                <div className={`navbar-menu ${isOpen ? 'is-active' : ''}`}>
                    <a href="/aichef/" className="navbar-item">Start</a>
                    <a href="/aichef/privacy-policy" className="navbar-item">Privacy Policy</a>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
